<div class="main">
    <h2 translate>home.lblStatistics</h2>
    <div class="dx-fieldset">
        <div class="dx-field">
            <div class="dx-field-label" translate>logs.lblEnvironment</div>
            <div class="dx-field-value" *ngIf="environments.length > 0 && selectedEnvironment">
                <app-environment-picker [environments]="environments" [(selectedItem)]="selectedEnvironment"
                    (selectedItemChange)="loadDataSource()"></app-environment-picker>
            </div>
        </div>
        <br />
        <dx-chart *ngIf="dataSourceSum > 0"
                  #logs
                  id="pie"
                  palette="material"
                  resolveLabelOverlapping="stack"
                  type="doughnut"
                  [dataSource]="dataSource">
            <dxo-legend horizontalAlignment="center" verticalAlignment="bottom"></dxo-legend>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-common-series-settings argumentField="eventType"
                                        type="bar"
                                        valueField="count"
                                        [ignoreEmptyPoints]="true">
                <dxo-label [visible]="true" format="fixedPoint" position="inside">
                    <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                </dxo-label>
            </dxo-common-series-settings>
            <dxo-series-template nameField="eventType"></dxo-series-template>
            <dxo-argument-axis><dxo-label [visible]="false"></dxo-label></dxo-argument-axis>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-size [height]="400"></dxo-size>
        </dx-chart>
    </div>
</div>
